import React from "react";
import API from "../../../utils/API";
import SectionHeader from '../../../components/views/SectionHeader';
import { Route, Switch } from "react-router-dom";
import LoadingWizard from "../../../components/spinner/wizard";
import CreateRegistrationFlowModal from "./modals/createRegistrationFlowModal";
import RegistrationFlowSetup from "./registrationSetup";
import RegistrationFlowListItem from "./registrationFlowListItem";
import DeleteFlowModal from "./modals/deleteFlowModal";

class RegistrationFlows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flows: [],
            addFlowModalOpen: false,
            deleteFlowModalOpen: false,
            focusedFlow: null,
            loading: true,
        }
    }
    componentDidMount() {
        const flows = this.props.program?.eventDefaults?.registrationFlows || [];
        const mappedFlows = flows.map((flow) => {
            return {
                ...flow,
                registrationGroup: flow.registrationGroup ? this.props.program.eventDefaults.groups.find((group) => group._id === flow.registrationGroup) : null,
            }
        });

        this.setState({ flows: mappedFlows, loading: false });
    }

    addRegistrationFlow = (flow, successCallback, errorCallback) => {

        this.props.addRegistrationFlow(flow, (newFlow, error) => {
            if (error) {
                errorCallback && errorCallback(error);
                return;
            }

            if (newFlow) {
                const mappedFlow = {
                    ...newFlow,
                    registrationGroup: newFlow.registrationGroup ? this.props.program.eventDefaults.groups.find((group) => group._id === newFlow.registrationGroup) : null,
                };

                this.setState((prevState) => ({
                    flows: [...prevState.flows, mappedFlow],
                    addFlowModalOpen: false
                }));

                successCallback && successCallback(newFlow);
            }
        });
    }

    updateRegistrationFlow = (flow) => {
        const { flows } = this.state;
        const index = flows.findIndex((f) => f._id === flow._id);
        if (index !== -1) {
            flows[index] = flow;
            this.setState({ flows });
        }
    }

    removeRegistrationFlow = (flowId) => {
        const { flows } = this.state;
        const flowToDelete = flows.find(f => f._id === flowId);

        if (!flowToDelete) {
            console.error('Flow not found for deletion');
            return;
        }

        this.props.deleteRegistrationFlow(flowToDelete, () => {
            const updatedFlows = flows.filter(f => f._id !== flowId);
            this.setState({ flows: updatedFlows });

            this.setState({ deleteFlowModalOpen: false, focusedFlow: null });
        });
    }
    createRegistrationFlow = (flow, cb) => {
        this.props.createRegistrationFlow(flow, () => {
            this.setState({
                editCount: this.state.editCount + 1,

            }, () => {
                cb && cb();
            });
        })
    }

    render() {
        const { flows, addFlowModalOpen, deleteFlowModalOpen, loading } = this.state;
        const { org, orgId, programId, program, fields, account, updateProgramGroups } = this.props;

        return (<Switch>
            <Route
                exact
                path={`/${orgId}/programs/${programId}/registrationFlows/:flowId`}
                render={({ match }) => {
                    const flowId = match.params.flowId;
                    const flow = flows.find(f => f._id === flowId);

                    return (
                        <RegistrationFlowSetup
                            program={program}
                            organization={org}
                            programId={programId}
                            orgId={orgId}
                            fields={fields}
                            account={account}
                            updateFlow={this.updateRegistrationFlow}
                            updateProgramGroups={updateProgramGroups}
                            removeFlow={this.removeRegistrationFlow}
                            flow={flow}
                            flowId={flowId}
                        />
                    );
                }}
            />
            <Route exact path={`/${orgId}/programs/${programId}/registrationFlows`}>
                <div className={`sectionContainer`}>
                    <SectionHeader
                        breadcrumbs={[
                            {
                                name: program.name
                            }
                        ]}
                        title="Registration Flows"
                        description="Event registration flows are used to determine how attendees register for your event. You can create multiple flows to accommodate different types of attendees."
                        mainActions={[
                            {
                                label: "Add Flow",
                                onClick: () => {
                                    this.setState({ addFlowModalOpen: true });
                                }
                            }
                        ]}
                    >
                    </SectionHeader>
                    <hr />
                    <div className="sectionContent mt-10">
                        {!loading && <div className="flex gap20">

                            {flows.length > 0 ? (
                                <div className="regFlowList">
                                    {flows.map((flow) => (
                                        <RegistrationFlowListItem
                                            flow={flow}
                                            key={flow._id}
                                            organization={this.props.org}
                                            program={this.props.program}
                                            toggleDeleteFlowModal={() => this.setState({ deleteFlowModalOpen: true, focusedFlow: flow })}
                                        />
                                    )
                                    )}
                                </div>
                            ) : (<div className="explainerBox">
                                <i className="las la-info-circle" style={{ fontSize: 50 }}></i>
                                <div>
                                    <h2>Create Your First Flow</h2>
                                    <p>No registration flows available. Please add a flow to get started.</p>
                                </div>
                            </div>
                            )}
                        </div>}
                        {loading && <LoadingWizard loading={loading} text="Loading Registration Flows" />}
                    </div>
                    {addFlowModalOpen && (<CreateRegistrationFlowModal
                        isOpen={addFlowModalOpen}
                        toggle={() => this.setState({ addFlowModalOpen: false })}
                        programId={programId}
                        orgId={orgId}
                        groups={program.eventDefaults.groups}
                        addGroup={this.props.addGroup}
                        updateFlows={this.addRegistrationFlow}
                        onError={(error) => {
                            console.error("Error adding flow:", error);
                        }}
                    />)}

                    {deleteFlowModalOpen && (
                        <DeleteFlowModal
                            isOpen={deleteFlowModalOpen}
                            toggle={() => this.setState({ deleteFlowModalOpen: false })}
                            flow={this.state.focusedFlow}
                            orgId={orgId}
                            eventId={program._id}
                            onDelete={(flowId) => {
                                this.removeRegistrationFlow(flowId);
                            }}
                        />
                    )}
                </div>
            </Route>
        </Switch>
        );
    }
}

export default RegistrationFlows;